import React from "react";
import { SingleLinkWidgetPreview } from "./";

const SingleLinkWidgetManage = ({ widget, userData }) => {
  return (
    <SingleLinkWidgetPreview widget={widget} userData={userData} />
  )
}

export default SingleLinkWidgetManage;